






import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import { getBaseInfo, wxSdkInfoZHBF } from './api';

const baseUrl = '20230531CQBGY';

@Component
export default class ViewHolder extends Vue {
  tabs: any[] = [];
  activeTab = 0;
  baseInfo: any = {};

  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/d/file/activity/2023-06-30/f4b3375fc6fe433cb723836067d29f66.jpg';
    // App分享
    this.$appShareInfo({
      title: '2023比亚迪校园达人共创大赛第二季｜重磅开启',
      url: location.href,
      subtitle: `循梦而行，创意无限；中国青年，带电态度！`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.wxShareInfo({
        title: '2023比亚迪校园达人共创大赛第二季｜重磅开启',
        subtitle: `循梦而行，创意无限；中国青年，带电态度!`,
        image:
          'https://image2.cqcb.com/d/file/activity/2023-06-30/f4b3375fc6fe433cb723836067d29f66.jpg',
        url:
          'https://activity.cqcb.com/shangyou_activity/2023h2/BYD0621/relink',
        // url:
        //   'https://8.u.mgd5.com/c/wnlw/z3vb/index.html?t=0&custom=&crid=&s=1&prev=liy6388hrh72pmfxpyrcnjlokqwdpykxbneddxm3&time=1688122281423&from=singlemessage',
      });
    }
  }

  async created() {
    console.log();
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
  }

  // 微信分享
  wxShareInfo(DetailsData: any) {
    wxSdkInfoZHBF({ jssdkurl: window.location.href }).then((res: any) => {
      const data = res.data;
      const e = DetailsData;
      const messageData = {
        title: e.title, // 分享标题
        desc: e.subtitle, // 分享描述
        link: e.url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
        imgUrl: this.getCoverImage(e), // 分享图标
      };
      this.wxConfig(data);
      window.wx.ready(() => {
        window.wx.updateAppMessageShareData({
          ...messageData,
        });
        window.wx.updateTimelineShareData({
          ...messageData,
        });
      });
    });
  }
  // 获取微信sdk
  wxConfig(statement: object) {
    window.wx.config({
      debug: false,
      ...statement,
      jsApiList: [
        // 所有要调用的 API 都要加到这个列表中
        'updateAppMessageShareData', // 分享到朋友
        'updateTimelineShareData', // 分享到朋友圈
        'onMenuShareAppMessage',
        'onMenuShareTimeline',
      ],
    });
  }
  // 分享图片处理
  getCoverImage(post: any) {
    if (post.image) {
      return post.image;
    } else {
      return 'http://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    }
  }
}
